import React, { HTMLAttributes, useEffect, useState } from 'react';
import { format } from 'date-fns';

interface PostInfosProps extends HTMLAttributes<HTMLDivElement> {
  publishDate: string;
}

export function PostInfos({ publishDate, ...props }: PostInfosProps) {
  const { className, ...otherProps } = props;
  const [formattedDate, setFormattedDate] = useState<string | undefined>(
    undefined
  );

  useEffect(() => {
    if (publishDate) {
      setFormattedDate(format(new Date(publishDate), 'MMM dd, yyyy'));
    }
  }, [publishDate]);

  return (
    <div
      className={`typography-body-2 flex items-center whitespace-nowrap font-[350] text-black ${className}`}
      data-testid="blog-post-infos"
      {...otherProps}
    >
      <span className="">{formattedDate}</span>
    </div>
  );
}
